export const Environment = {
    baseUrl: "https://tali.kindisland-248dcc29.eastus2.azurecontainerapps.io/api",

    microsoftSPARedirectUri: "https://tali-uat.ensue.com.np/auth/microsoft/callback",
    microsoftSPALogoutRedirectUri: "https://tali-uat.ensue.com.np/auth/microsoft/logout",
    microsoftSPAClientId: "3f37ca9e-5c76-4581-ad6f-cfef917e9b0b",
    microsoftSPABackendClientId: "adda6589-747d-452b-892a-1d198acc7cab",
    microsoftSPAAuthority: "https://login.microsoftonline.com/6217bcea-e5ae-4e84-975b-f5e445a2c94c",

    socketUrl: "https://tali.kindisland-248dcc29.eastus2.azurecontainerapps.io",
};
